export { default } from "./ProjectApprovalsV2Mspa";
